export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-ac0df80f8d89e7d00f27.worker.js");
}
